import React from 'react';
import { Stack, Text } from 'rsuite';
import { Person } from 'src/types/person';
import { ROLES_INFO } from './types';

interface PersonDataProps {
  personDetails: Person;
  role: string;
  number: number;
}

export const PersonData = ({
  personDetails,
  role,
  number,
}: PersonDataProps) => {
  return (
    <Stack
      direction="column"
      alignItems="flex-start"
    >
      <h3>
        {role} {ROLES_INFO.OWNER === role && number && ` #${number}`}
      </h3>
      <Text className="text-bold">First Name</Text>
      <Text className="mb-4">{personDetails?.firstName}</Text>
      <Text className="text-bold">Last Name</Text>
      <Text className="mb-4">{personDetails?.lastName}</Text>
      <Text className="text-bold">Company Name</Text>
      <Text className="mb-4">{personDetails?.companyName}</Text>
      <Text className="text-bold">Phone Number</Text>
      <Text className="mb-4">{personDetails?.phone}</Text>
      <Text className="text-bold">Email</Text>
      <Text className="mb-4">{personDetails?.email}</Text>
      <Text className="text-bold">Mailing Address</Text>
      <Text className="mb-4">{personDetails?.mailingAddress}</Text>
    </Stack>
  );
};
